const $en = {
    HEY: "Hey",
    YOU_ARE_ON: "You are on",
    LEVEL: "Level",
    SPIN_NOW: "Spin Now",
    SPIN_NOW_2: "Spin\nNow",
    QUESTIONS: "Questions",
    MINUTES: "Minutes",
    PLAY_FREE: "Play Free",
    PLAY_USING: "Play using",
    USING_COINS: "Coins",
    LATEST_TOURNAMENTS: "Latest Tournaments",
    DAILY_TOURNAMENTS: "Daily Tournaments",
    MEGA_TOURNAMENTS: "Mega Tournaments",
    LATEST_CHALLENGE_ROOM: "Latest Challenges",
    SEE_ALL: "See all",
    CATEGORIES: "Trial Quizzes",
    TOP_TOPICS: "Top Topics",
    YOUR_INTEREST: "Your Interest",
    YOU_HAVE_COMPLETED: "You have completed",
    LEADERBOARD: "Leaderboard",
    STORE: "Store",
    FRIENDS: "Friends",
    REFER: "Refer",
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
    REQUEST: "Request",
    LANGUAGE: "Language",
    SENT_REQUEST: "Sent Request",
    YOU_HAVE_NO_FRIENDS: "You have no friends yet",
    EMPTY_REQUEST: "Empty Request",
    YOU_CAN_ADD_FRIEND: "You can add friends as you wish",
    SEARCH_FRIEND: "Search Friends",
    TERMS_CONDITION: "Terms & Conditions",
    PRIVACY: "Privacy",
    COINS: "Coins",
    GEMS: "Gems",
    YOUR_BALANCE: "Your Balance",
    BUY_NOW: "Buy Now",
    BDT: "LKR",
    TOP_DEALS: "Top Deals",
    POPULAR_PRODUCTS: "Popular Products",
    RS: "RS",
    SEARCH_TOPICS: "Search Topics",
    PROFILE: "Profile",
    NOTIFICATIONS: "Notifications",
    SETTINGS: "Settings",
    CHALLENGES: "Challenges",
    NO_HISTORY_AVAILABLE: "No history available",
    PURCHASE_HISTORY: "Purchase History",
    INVITE_FRIENDS: "Invite Friends",
    RATE_QUIZGIRI: "Rate QuizGiri",
    CHALLENGE_WINNING_STATUS: "Challenge Winning Status",
    WIN: "Win",
    DRAW: "Draw",
    LOSS: "Loss",
    BCS_TEST_RESULT: "BCS Test Results",
    TODAY: "Today",
    THIS_WEEK: "This Week",
    THIS_MONTH: "This Month",
    MODEL_TEST_PARTICIPATED: "Model Test Participated",
    QUESTION_ANSWERED: "Question Answered",
    MARK: "Mark",
    CORRECT: "Correct",
    WRONG: "Wrong",
    SKIPPED: "Skipped",
    CANCEL: "Cancel",
    EDIT_PROFILE: "Edit Profile",
    FULL_NAME: "Full Name",
    MOBILE: "Mobile",
    EMAIL: "Email",
    SAVE: "Save",
    WEEKLY_TASK: "Weekly Task",
    DAY: "Day",
    PLAY_NOW: "Play Now",
    FREE_QUIZ_PLAY: "Free Quiz Play",
    OUT_OF_COIN: "Out of Coin",
    STARTING_NOW: "Starting",
    ALREADY_PLAYED: "Already Played",
    RECENT_BEST: "Recent Best",
    REPORT: "Report",
    NEXT: "Next",
    USE_COIN: "Use Coin",
    SEE_RESULT: "See Result",
    WATCH_VIDEO: "Watch Video",
    TI: "",
    YOU_HAVE_GIVEN: "You Have Given",
    CORRECT_ANS: "Correct Answer",
    TOTAL_QUESTION: "Total Question",
    THANKS_FOR_PLAYING: "Thanks for Playing",
    YOU_HAVE_COMPLETED_TODAYS_TASK: "You have completed today's task",
    DONE: "Done",
    TIME: "Time",
    PENALTY: "Penalty",
    WRONG_QUESTION: "Wrong Question",
    WRONG_ANSWER: "Wrong Answer",
    OTHERS: "Others",
    SUBMIT: "Submit",
    REPORTED: "Reported",
    SUBMITTED: "Submitted",
    PLEASE_CONFIRM: "Please Confirm",
    FOLLOW: "Follow",
    FAQ: "FAQ",
    FOLLOWING: "Following",
    FOLLOWER: "Follower",
    YOUR_LEVEL: "Your Level",
    NEXT_LEVEL: "Next Level",
    PLAY: "Play",
    EXPLORE: "Explore",
    CHOOSE_BET_AMOUNT: "Choose bet amount",
    TYPE_OF_CHALLENGE: "Type of challenge",
    SINGLE_TOPIC: "Single topic",
    GLOBAL: "Global",
    SELECT_TOPIC_CATEGORY: "Select topic category",
    SELECT_TOPIC: "Select topic",
    SELECT_QUESTION_AMOUNT: "Select question amount",
    CONFIRM: "Confirm",
    CHALLENGE_NOW: "Challenge Now",
    RESULT: "Result",
    ACCEPTED: "Accepted",
    ACCEPT: "Accept",
    REJECTED: "Rejected",
    REJECT: "Reject",
    CANCELLED: "Cancelled",
    PENDING: "Pending",
    NO_CHALLENGE: "You have no challenge yet",
    CHALLENGE: "Challenge",
    COMPLETED: "Completed",
    OPPONENT_PLAYED: "Opponent played",
    OPPONENT_NOT_PLAYED: "Opponent hasn't played",
    PLAYED: "Played",
    CONGRATULATION: "Congratulation",
    YOU_HAVE_SUCCESSFULLY_PURCHASED: "You have successfully purchased",
    NOW_YOU_CAN_PARTICIPATE_TOURNAMENT: "Now you can participate tournament",
    GO_HOME: "Go Home",
    HOME: "Home",
    YOU_WON: "You Won",
    YOU_CAN_SPIN_ONLY_ONCE: "You can spin only one time in a day. But you can spin again by watching ad",
    DAILY_SPIN: "Daily Spin",
    YOUR_NEXT_SPIN: "Your next spin will be available in",
    SHARE: "Share",
    NOTHING_FOUND: "Nothing found",
    THIS_YEAR: "This Year",
    FILTER: "Filter",
    SEARCH_WITH_NAME_OR_EMAIL: "Search with name or email",
    PEOPLE_FROM_CONTACT: "Peoples from your contact",
    SELECT_FRIEND: "Select a Friend",
    DAILY_UPDATE: "Daily Update",
    NEW_TOPIC: "New Topic",
    NEW_TOURNAMENT: "New Tournament",
    SOUND_EFFECT: "Sound Effect",
    MUSIC: "Music",
    LOGOUT: "Logout",
    TOURNAMENT: "Tournament",
    CHALLENGE_ROOM: "Challenge Room",
    PARTICIPANTS_ARE_PLAYING: "Participants are playing",
    TIME_UP: "Time up",
    SUBSCRIBE_NOW: "Subscribe Now",
    UNSUBSCRIBE_NOW: "Unsubscribe Now",
    YOU_CANT_PLAY_MORE: "You can't play more",
    PARTICIPATE_IN_OTHER_TOURNAMENTS: "Participate in other tournaments",
    FIFTY_FIFTY: "50:50",
    GET_ANSWER: "Get Answer",
    BKASH: "bKash & Others",
    REMOVE_BKASH_ACCOUNT: "Remove bkash account",
    ADD_BKASH_ACCOUNT: "Add your bkash account",
    TOTAL_POINTS: "Total Point",
    HIGH_SCORE_IN_ANY_TOPIC: "Hign Score in Any Topic",
    TOURNAMENT_WIN: "Tournament Win",
    ADD_FRIEND: "Add Friend",
    CANCEL_REQUEST: "Cancel Request",
    ACCEPT_REQUEST: "Accept Request",
    REQUEST_SENT: "Request Sent",
    UNAVAILABLE: "Unavailable",
    REMATCH: "Rematch",
    OKAY: "okay",
    USE_OF_COIN: "User of Coin",
    USE_OF_COIN_1: "1. While challenging your friend, you must have at least the bet amount of coins in your wallet",
    USE_OF_COIN_3: "3. While playing tournament, you can use lifeline by spending coins",
    USE_OF_GEM: "Use of Gem",
    USE_OF_GEM_1:
        "1. While playing tournament, you can get the correct answer of a question by spending gems",

    SURE_TO_EXIT: "Are you sure to exit?",
    SURE_TO_UNSUBSCRIBE: "are you sure to unsubscribe the service?",
    YES: "Yes",

    NO: "No",
    YOU_HAVE_NOT_SUBMITTED_ANSWERS: "You haven't submitted your answers",

    SURE_TO_QUIT: "Are you sure to quit?",

    YOU_HAVE_NOT_COMPLETED_THE_GAME: "You haven't completed the game",

    TRY_AGAIN: "Try Again",
    NEXT_TOPIC: "Next Topic",
    NOT_BAD: "Not Bad",
    BETTER_LUCK_NEXT_TIME: "Better Luck Next Time",

    YOU_HAVE_PASSED: "You have passed this stage",


    YOU_HAVE_FAILED: "You have failed this stage",
    NO_IMPROVEMENT: "You have no improvement",

    PLEASE_NOTE: "Please Note",

    TOTAL_CHANCE: "Total Chances",

    CHANCE_PLAYED: "Chances Played",

    START: "Start",
    START_TIME: "Start-Time",
    END_TIME: "End-Time",
    ENTER_PASSCODE: "Enter Passcode",

    VERIFY: "Verify",

    PAY_TO_PLAY: "Pay to Play",

    WILL_PUBLISH_RESULT_SOON: "We will publish the result soon",


    SORRY: "Sorry",
    SORRY_MSG: "Unsubscription is not successful",
    SUCCESS: "Success",
    SUCCESS_MSG: "Unsubscription Successful",
    FEATURE_AVAILABLE_IN_APP: "This feature is not available in web",


    DOWNLOAD_NOW: "Download Now",
    WHY_DOWNLOAD_APP: "To enjoy more exciting features, get the app",


    ALREADY_PURCHASED_BUNDLE: "Already Purchased Bundle?",


    SIGN_IN_TO_PLAY: "Sign in to QuizGiri to play",

    SIGN_IN_NOW: "Sign In Now",

    ENTER_NAME: "Enter your name",


    ENTER_MOBILE: "11 digit mobile number",

    CREATE_ACCOUNT_WITH_SAME_MOBILE: "[NOTICE: Please make sure you have or you are going to create QuizGiri account with this given number]",


    PROCEED: "Proceed",


    PURCHASE_PACK: "Purchase Pack",

    PAYMENT_METHOD: "Payment Methods",


    SELECT_PAYMENT_METHOD: "Select payment method",


    BCS_PACKAGES: "BCS Packages",

    TOURNAMENT_BUNDLES: "Tournament Bundles",


    SUBSCRIPTION: "subscription",

    SUBSCRIBED: "Subscribed",

    DUMMY: "dummy",
    DASHBOARD: 'Dashboard',
    MEGA: 'Mega',
    ERROR: 'Error'
}

export default $en
